<ion-col size="12" *ngIf="valgtAnlegg">
  <ion-row class="cost-info-row">
    <ion-col>
      <ion-row class="full-h">
        <ion-col class="box-col-nokkeltall ml-3-wide">
          <p>
            Strøm
            {{
              selectedDate.toLocaleDateString('nb-NO', {
                month: 'long'
              })
            }}
          </p>
          <p *ngIf="isPlusskunde">netto etter inntekt</p>
          <p class="large-number-total">{{ toRoundNumber(stromTotal) }} kr</p>
          <div class="flex-row">
            <p>Forbruk hittil</p>
            <p>{{ toRoundNumber(stromForbrukbelop) }} kr</p>
          </div>
          <div class="flex-row" *ngIf="isPlusskunde">
            <p>Inntekter hittil</p>
            <p>{{ toRoundNumber(inntektProd) }} kr</p>
          </div>
          <div class="flex-row">
            <p>Fastbeløp totalt</p>
            <p>{{ toRoundNumber(stromFastbelop) }} kr</p>
          </div>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size="12" sizeSm="6" *ngIf="valgtAnlegg.gjennomfakturering">
      <ion-row>
        <ion-col class="box-col-nokkeltall ml-3-narrow">
          <p>
            Nettleie
            {{
              selectedDate.toLocaleDateString('nb-NO', {
                month: 'long'
              })
            }}
          </p>
          <p *ngIf="isPlusskunde">&nbsp;</p>
          <p class="large-number-total">
            {{ toRoundNumber(nettleieTotal) }} kr
          </p>
          <div class="flex-row">
            <p>Forbruk hittil</p>
            <p>{{ toRoundNumber(nettleieEnergiledd) }} kr</p>
          </div>
          <div class="flex-row">
            <p>Avgifter hittil</p>
            <p>{{ toRoundNumber(nettleieAvgifter) }} kr</p>
          </div>
          <div class="flex-row">
            <p>Fastbeløp totalt</p>
            <p>{{ toRoundNumber(nettleieFastbelop) }} kr</p>
          </div>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="isStromstotteToggled">
    <ion-col size="12">
      <app-stromstotte-month
        [valgtAnlegg]="valgtAnlegg"
        [valgtAvtale]="valgtAvtale"
        [selectedDate]="selectedDate"
        [foretakMap]="_foretakMap"
      ></app-stromstotte-month>
    </ion-col>
  </ion-row>
</ion-col>
